import { Component, OnInit } from '@angular/core';
import { CrudService } from '../crud.service';
@Component({
  selector: 'app-director-message',
  templateUrl: './director-message.component.html',
  styleUrls: ['./director-message.component.scss']
})
export class DirectorMessageComponent implements OnInit {

  constructor(private crudService: CrudService) { }
  baseUrl = this.crudService.baseUrl;
  ngOnInit(): void {
  }

}
